<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
    export default {
      name: "Member",
      methods:{
        // isLogin(){
        //   let that = this;
        //   if (!that.$store.state.loginType){
        //     that.$router.push('/login')
        //   }
        // }
      },
      mounted:function () {
        // this.isLogin();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Member.vue